jQuery(document).ready(function ($) {
	// Handle adding array items
	$(document).on('click', '.add-array-item', function () {
		var $container = $(this).closest('.array-fields');
		var $template = $container.find('.array-item-template .array-item').clone();
		$template.find('input, select, textarea').val('');
		$(this).before($template);
	});

	// Handle removing array items
	$(document).on('click', '.remove-array-item', function () {
		$(this).closest('.array-item').remove();
	});
});
